import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../components/Button/PrimaryButton";
import OtpTextField from "../components/TextField/OtpTextField";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import { StaticAPI } from "../utils/StaticAPI";
import * as API from "../utils/service";
import { useFormik } from "formik";
import * as Yup from "yup";
import { StaticRouterLinks } from "../utils/StaticRouterLinks";
import ErrorToster from "../components/TosterComponents/ErrorToster";
import { Bounce, toast } from "react-toastify";
import SuccessToster from "../components/TosterComponents/SuccessToster";
import * as utils from "../utils/utils";
import { TextField } from "@mui/material";

export default function LoginOTP() {
  const [loading, setLoading] = useState(false);
  const [secondsLeftUccOTP, setSecondsLeftUccOTP] = useState(30);
  const submitUccIdCalled = useRef(false);
  const navigate = useNavigate();

  let [searchParams, setSearchParams] = useSearchParams();

  let [query, setQuery] = useState({
    ucc: searchParams.get("ucc"),
  });

  const otpForm = useFormik({
    initialValues: {
      otp: "",
    },
    // validationSchema: otpValidationSchema,
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const payload = {
        ucc: query?.ucc || localStorage.getItem("ucc"),
        otp: values.otp,
      };
      API.daoPostMethod(StaticAPI.emailOtpVerify, payload)
        .then((response) => {
          setLoading(false);
          localStorage.setItem("token", response?.token);
          toast(
            <SuccessToster successMessage={"UCC verification successfully"} />,
            {
              toastId: "ucc-otp-verify-success",
            }
          );
          navigate(
            {
              pathname: StaticRouterLinks.document,
              search: `?${createSearchParams({
                ucc: query?.ucc,
                userid: response?.data?.userid,
              })}`,
            },
            { replace: true }
          );
        })
        .catch((error) => {
          console.log(error);

          toast(<ErrorToster errorMessage={error?.response?.data?.message} />, {
            toastId: "ucc-otp-verify-error",
          });
          setLoading(false);
        });
    },
  });

  const navigateToHome = () => {
    navigate(
      {
        pathname: StaticRouterLinks.home,
        search: `?${createSearchParams({
          ucc: query?.ucc || localStorage.getItem("ucc"),
        })}`,
      },
      { replace: true }
    );
  };
  const submitEmailId = () => {
    setLoading(true);
    const payload = {
      ucc: localStorage.getItem("ucc").toLocaleLowerCase(),
    };
    API.daoPostMethod(StaticAPI.initiateKyc, payload)
      .then((response) => {
        if (!utils?.isNullOrUndefined(response?.message)) {
          toast(<SuccessToster successMessage={response?.message} />, {
            toastId: "ucc-otp-success",
          });
          setLoading(false);
        } else {
          toast(<ErrorToster errorMessage={response.message} />, {
            toastId: "ucc-otp-error",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        if (
          error?.response?.data?.message !==
          "Please wait atleast 30 seconds before requesting for otp again!"
        )
          navigate("/");
        toast(<ErrorToster errorMessage={error?.response?.data?.message} />, {
          toastId: "ucc-otp-error",
        });
      });
  };
  const resendEmailOTP = () => {
    if (secondsLeftUccOTP === 0) {
      submitEmailId();
      setSecondsLeftUccOTP(30);
    } else return null;
  };

  useEffect(() => {
    if (!submitUccIdCalled.current) {
      submitEmailId();
      submitUccIdCalled.current = true;
    }

    if (secondsLeftUccOTP === 0) return;

    const countdownInterval = setInterval(() => {
      setSecondsLeftUccOTP((prevSecondsLeft) => {
        if (prevSecondsLeft === 0) {
          clearInterval(countdownInterval);
          return 0;
        } else {
          return prevSecondsLeft - 1;
        }
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [secondsLeftUccOTP]);

  return (
    <div className="flex flex-col items-center gap-10 w-[88%] lg:w-[72%]  max-w-[335px] h-full lg:h-auto pb-[30px] pt-[140px] lg:p-0 ">
      <div className="flex flex-col gap-12 lg:gap-3 text-center">
        <span className="text-xl font-medium">Check your Inbox</span>
        <div className="flex flex-col gap-2 text-xs font-normal ">
          <span className="text-base text-pkt-subheading">
            Enter the 6 digit OTP sent to
          </span>
          <div
            className="flex flex-row justify-center items-center gap-[7px] cursor-pointer"
            onClick={navigateToHome}
          >
            <span className="text-pkt-heading">
              {query?.ucc || localStorage.getItem("ucc")}
            </span>
            <img
              src={`${process.env.PUBLIC_URL || ""}/images/signup-page-images/ucc-otp/edit-pen.svg`}
              alt="edit-pen"
            />
          </div>
        </div>
      </div>
      <form
        onSubmit={otpForm.handleSubmit}
        className="flex flex-col justify-center items-center gap-[38px] w-full"
      >
        {/* <OtpTextField
          handlePinChange={handlePinChange}
          handleKeyDown={handleKeyDown}
          error={handleErrorForPin()}
        /> */}
        <div className="flex flex-col justify-center w-full gap-0.5">
          <TextField
            id="outlined-basic"
            label={"Enter OTP"}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#000",
                fontSize: "14px",

                fontFamily: "inherit",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EAEAEA",
                  borderWidth: "1px",
                  borderRadius: "10px",
                },
                "&.Mui-focused": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#2795BF",
                    borderWidth: "2px",
                    borderRadius: "10px",
                  },
                },
                "&:hover:not(.Mui-focused)": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                    borderRadius: "10px",
                  },
                },
              },
              "& .MuiInputLabel-outlined": {
                color: "#918F90",
                fontSize: "14px",
                fontFamily: "inherit",
                "&.Mui-focused": {
                  color: "#2795BF",
                },
              },
            }}
            value={otpForm?.values?.otp}
            onChange={otpForm?.handleChange}
            name="otp"
            type="text"
            // error={otpForm.touched.ucc}
            error={otpForm.touched.otp ? otpForm.touched.otp : false}
          />
          {(otpForm.touched.otp || otpForm.isSubmitting) &&
          otpForm.errors.otp ? (
            <span className="errorTextField">{otpForm.errors.otp}</span>
          ) : null}
        </div>
        <div className="hidden lg:block w-full">
          <PrimaryButton
            size={"large"}
            name={"Continue"}
            height={"50px"}
            borderRadius={"10px"}
            type="submit"
            // loading={loading}
          />
        </div>
      </form>
      <div className="flex flex-col gap-3 text-center text-xs text-pkt-subheading">
        <span>Didn't receive the OTP?</span>
        {secondsLeftUccOTP !== 0 ? (
          <span
            className={`${
              secondsLeftUccOTP === 0 ? "hidden" : "block"
            } text-sm font-medium text-pkt-heading`}
          >
            ({secondsLeftUccOTP}.00s)
          </span>
        ) : (
          <span
            onClick={resendEmailOTP}
            className={` ${
              secondsLeftUccOTP === 0 ? "text-pkt-primary cursor-pointer" : ""
            } text-sm font-medium`}
          >
            Send Again
          </span>
        )}
      </div>
      <form
        onSubmit={otpForm.handleSubmit}
        className="flex lg:hidden items-end w-full h-full"
      >
        <PrimaryButton
          size={"large"}
          name={"Verify"}
          height={"50px"}
          borderRadius={"10px"}
          type="submit"
          loading={loading}
        />
      </form>
    </div>
  );
}
